import $ from 'jquery';
import '../vendor/jquery-livequery.min.js'

const onOnce = (selector, func) => {
    const DOM = $('.main-container');
    DOM.livequery(selector, () => {
        func();
        DOM.expire(selector);
    });
};

onOnce('#block-tifaktor-content', () => {
    setTimeout(() => {
        const ctl = $('.main-container .contextual-links');
        let last;
        if(ctl.length > 1) {
            ctl.each((i, e) => {
                if(i !== 0) {
                    if(true) {
                        $(ctl[0]).append('<hr>');
                        $(ctl[0]).append($(e).children());
                    }
                    last = e;
                }
            });
        }
    }, 750);
});